import { Skeleton } from '@mint-lib/tw-components';

import { TableHeaderCell } from '../molecules/TableComponents.jsx';

export const TableHeadCellSkeleton = () => {
  return (
    <TableHeaderCell className="[&>div]:w-full">
      <Skeleton variant="rounded" className="h-4 w-full" />
    </TableHeaderCell>
  );
};
